<template>
  <div class="changeFloor">
    <van-nav-bar
      title="选择楼层"
      left-arrow
      right-text="确认"
      @click-left="onCancel"
      @click-right="onConfirm"
    />
    <van-tree-select
      ref="selectTree"
      :items="list"
      :active-id.sync="activeId"
      :main-active-index.sync="activeIndex"
      style="height: 100vh"
      @click-item="clickItem"
    />
  </div>
</template>

<script>

import { TreeSelect, NavBar } from 'vant';
import { getFloor } from '@/api/user';
export default {
  name: 'ChangeFloor',
  components: {
    [TreeSelect.name]: TreeSelect,
    [NavBar.name]: NavBar
  },
  data() {
    return {
      list: [],
      floorInfo: {},
      activeId: 1,
      activeIndex: 0
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    const selectTree = this.$refs.selectTree;
    selectTree.style.height = '100vh';
  },
  methods: {
    getList() {
      const data = this.$store.state.floorInfo;
      this.activeId = data.id;
      getFloor({}).then(res => {
        res.data.forEach((item, index) => {
          if (item.id === data.parentId) {
            this.activeIndex = index;
          }
          item.text = item.name;
          item.children = item.nodes;
          item.children.forEach(son => {
            son.text = son.name;
            son.parentName = item.name;
            son.parentId = item.id;
          });
        });
        this.list = res.data;
      });
    },
    onCancel() {
      this.$router.go(-1);
    },
    onConfirm() {
      this.$store.dispatch('setFloorInfo', { data: this.floorInfo });
      this.$router.go(-1);
    },
    clickItem(e) {
      this.floorInfo = e;
    }
  }
};
</script>

<style scoped>
  .changeFloor {
    height: 100vh;
    /deep/.van-tree-select {
      height: 100vh;
    }
  }
</style>
